/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import * as React from "react";
import { usePathname } from "next/navigation";

/** Announces route changes to screen readers by reading the current document title. */
export function RouteAnnouncer() {
  const pathname = usePathname();
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    // Defer to allow title updates
    const id = window.setTimeout(() => {
      setMessage(document.title || "");
    }, 50);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  );
}
